import { ThemeOptions } from '@mui/material'

import { AppPalette } from '../colors'

export const customPalette: ThemeOptions['palette'] = {
  primary: {
    main: AppPalette.YELLOW.main
  },
  text: {
    main: AppPalette.YELLOW.main,
    secondary: AppPalette.GREY.darker
  },
  background: {
    default: 'rgba(0,0,0,0)',
    overrideDefault: AppPalette.NEUTRAL.dark,
    // default: AppPalette.GREY.dark,
    hoverFirst: AppPalette.GREY.secondary,
    bgIcon: AppPalette.GREY.fourth
  }
}
